import type { HeightProps } from '@/animations/height/height.types';
import { motion } from 'motion/react';
import { useRef } from 'react';
import { useResizeObserver } from 'usehooks-ts';

export default function HeightAnimation(props: HeightProps) {
  const { children, on = false, duration = 0.5, className } = props;
  const ref = useRef<HTMLDivElement>(null);
  const { height = 0 } = useResizeObserver({
    ref,
    box: 'border-box',
  });

  return (
    <motion.div
      data-testid='height-animation'
      className={className}
      style={{ overflow: 'hidden' }}
      animate={{ height: on ? height : 0 }}
      initial={{ height: 0 }}
      transition={{ duration, ease: 'easeInOut' }}
    >
      <div ref={ref}>{children}</div>
    </motion.div>
  );
}
